import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import DatePickerComponent from "../../components/DatePickerComponent";
// import MobileNumberOTPForm from "../../components/MobileNumberOTPForm";
import VaccineSchedulesWrpr from "../../components/VaccineSchedulesWrpr";
import { Nav } from "react-bootstrap";

function VaccineSchedulerSection() {
  const [showNumField, setShowNumField] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [scheduleDates, setScheduleDates] = useState(null);
  // const [showMobileOtpForm, setShowMobileOtpForm] = useState(false);

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const handleFDoseDateSubmit = (e) => {
    e.preventDefault();
    if (!selectedDate) {
      alert("Please select a date.");
      return;
    }

    const firstDoseDate = new Date(selectedDate);

    setScheduleDates({
      firstDoseDate: formatDate(firstDoseDate),
      secondDoseDate: formatDate(addDays(firstDoseDate, 3)),
      thirdDoseDate: formatDate(addDays(firstDoseDate, 7)),
      fourthDoseDate: formatDate(addDays(firstDoseDate, 14)),
      fifthDoseDate: formatDate(addDays(firstDoseDate, 28)),
    });

    setShowNumField(true);
  };

  return (
    <Wrapper id="vaccSchdSec" className="my-md-2 mt-3 mb-3">
      <div className="far-card">
        <div className="far-card-content">
          <h2 className="mb-0 heading-2 primaryColor">
            Anti Rabies Vaccination Schedule
          </h2>
          <p className="regimen-text">
            Post Exposure Prophylaxis 5-Dose Intramuscular Essen Regimen
          </p>
          <p className="date-label secondaryColor">
            Select 1st Dose Vaccine Date
          </p>

          <form onSubmit={handleFDoseDateSubmit} className="dose-form">
            <DatePickerComponent setSelectedDate={setSelectedDate} label={""} />
            <Button type="submit" className="btnRVS" variant="outlined">
              Get Scheduled Dates
            </Button>
          </form>
        </div>
        <div className="color-box"></div>
        <div className="dots-box"></div>
      </div>

      {showNumField && (
        <div className="schedule-result">
          <h2 className="heading-3 mb-2 secondaryColor text-center">
            Your 5 Doses Schedule
          </h2>
          {scheduleDates && (
            <VaccineSchedulesWrpr scheduleDates={scheduleDates} />
          )}
          <div className="reminder-box">
            <p>
              To get the SMS reminder of next vaccine doses in your mobile
              please click the button below
            </p>
            <Nav.Link
              href={`/rabies-vaccine-schedule-reminder/${selectedDate}`}
              className="p-0"
            >
              <Button className="btnRVS">Get Reminder</Button>
            </Nav.Link>
          </div>
        </div>
      )}
    </Wrapper>
  );
}

export default VaccineSchedulerSection;

const Wrapper = styled.div`
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
  overflow: hidden;
  background: var(--whiteColor, #fff);

  /* ================= DESKTOP (default) ================= */
  .far-card {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    min-height: 325px; /* grows if content needs more room */
    padding: 32px 48px;
    overflow: hidden;
    z-index: 0;

    /* Image lives in a pseudo-element so it always covers its area
       without stretching or leaving gaps */
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 50%;
      background-image: url("/images/rabiesVaccSchedule.jpg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      z-index: -2;
    }

    .far-card-content {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .color-box,
    .dots-box {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(30%, -50%) rotate(-20deg);
      width: 80%;
      height: 250%;
      z-index: -1;
      pointer-events: none;
    }

    .color-box {
      background-color: white;
    }

    .dots-box {
      background-image: url("/images/svg/dots.png");
      background-size: contain;
      background-position: top center;
      opacity: 0.2;
    }
  }

  .heading-2 {
    line-height: 1.25;
    word-break: break-word;
  }

  .regimen-text {
    margin: 20px 0 4px;
    line-height: 1.5;
  }

  .date-label {
    margin: 20px 0 8px;
  }

  .dose-form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    width: 100%;

    .MuiFormControl-root,
    .MuiTextField-root,
    input {
      width: 100%;
    }
  }

  .btnRVS {
    background-color: var(--secondaryColor);
    color: var(--whiteColor);
    border: 2px solid var(--secondaryColor);
    padding: 8px 20px;
    &:hover {
      border: 2px solid var(--secondaryColor);
      color: var(--secondaryColor);
      background-color: var(--whiteColor);
    }
  }

  .schedule-result {
    padding: 48px;
  }

  .reminder-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 40px;
    gap: 8px;

    p {
      max-width: 520px;
      margin: 0;
      line-height: 1.5;
    }
  }

  /* ================= TABLET (≤ 991px) ================= */
  @media only screen and (max-width: 991.98px) {
    .far-card {
      padding: 28px 28px;

      &::before {
        width: 45%;
      }

      .far-card-content {
        width: 58%;
      }

      .color-box,
      .dots-box {
        transform: translate(25%, -50%) rotate(-15deg);
        width: 85%;
      }
    }

    .schedule-result {
      padding: 32px 24px;
    }
  }

  /* ================= MOBILE (≤ 767px) ================= */
  @media only screen and (max-width: 767.98px) {
    .far-card {
      flex-direction: column;
      align-items: stretch;
      min-height: 0;
      /* top padding = image height + gap, so text never sits on the photo */
      padding: 240px 18px 24px;

      &::before {
        width: 100%;
        height: 220px;
        bottom: auto;
        background-position: center 30%;
      }

      .far-card-content {
        width: 100%;
      }

      /* white panel only under the image, no diagonal */
      .color-box,
      .dots-box {
        top: 220px;
        right: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        transform: none;
      }

      .dots-box {
        background-size: 300px;
        background-repeat: repeat;
        opacity: 0.12;
      }
    }

    .heading-2 {
      font-size: 1.35rem;
    }

    .regimen-text {
      margin-top: 12px;
    }

    .date-label {
      margin-top: 16px;
    }

    .dose-form .btnRVS {
      width: 100%;
    }

    .schedule-result {
      padding: 24px 16px;
    }

    .reminder-box {
      margin-top: 28px;

      a,
      .btnRVS {
        width: 100%;
      }
    }
  }

  /* ================= SMALL PHONES (≤ 375px) ================= */
  @media only screen and (max-width: 375px) {
    .far-card {
      padding: 200px 14px 20px;

      &::before {
        height: 180px;
      }

      .color-box,
      .dots-box {
        top: 180px;
      }
    }

    .heading-2 {
      font-size: 1.2rem;
    }
  }
`;
